import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { version } from '../../../../package.json';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @Input() RightNavData: any;
  isLogin: boolean = true;
  isRegistration: boolean = false;
  isHomePage: boolean = true;
  isForgotPassword: boolean = false;
  public appVersion = version;
  @ViewChild("contentRight") contentRight;
  constructor(
    private route: ActivatedRoute,
    private router: Router, 
    private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.loggedIn()) {
      this.router.navigateByUrl('/dashboard');
    }
    if(this.route.snapshot.queryParams.registration == ""){
      this.isRegistration = true;
     this.isLogin = false;
    }
  }
  resetView() {
    this.isLogin = true;
    this.isRegistration = false;
    this.isForgotPassword = false;
  }
  loginCheck(isLogin) {

    this.contentRight.drawer.toggle();
    this.isLogin = true;
    this.isRegistration = false;
    this.isForgotPassword = false;
    //this.router.navigateByUrl('/login');
  }
  onDataEvent(event) {
    switch (event.key) {
      case 'registration':
        this.isLogin = false;
        this.isRegistration = true;
        this.isForgotPassword = false;
        break;
      case 'success':
        //this.contentRight.drawer.toggle();
        this.isLogin = true;
        this.isRegistration = false;
        this.isForgotPassword = false;
        break;
      case 'loginView':
        this.isLogin = true;
        this.isRegistration = false;
        this.isForgotPassword = false;
        break;
      case 'forgotPassword':
        this.isForgotPassword = true;
        this.isLogin = false;
        this.isRegistration = false;
        break;

    }
  }
}
